import { useParams, useNavigate, Link } from "react-router-dom";
import { useOne } from "@refinedev/core";
import { useAuth } from "@/hooks/useAuth";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { EstadoBadge } from "@/components/forms/EstadoBadge";
import { formatDate } from "@/lib/formatters";

export function CorteDetallePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isOperador } = useAuth();
  const { data } = useOne({
    resource: "periodos_cobro",
    id,
    meta: { select: "*, tiendas(nombre)" },
  });

  if (!data?.data) return <div className="card p-8 text-center">Cargando...</div>;
  const p = data.data;

  return (
    <div className="max-w-2xl space-y-4">
      <PageHeader
        title={`Corte #${p.numero_correlativo}`}
        subtitle={`${formatDate(p.fecha_inicio)} — ${formatDate(p.fecha_fin)}`}
        actions={<EstadoBadge estado={p.estado as "abierto"} />}
      />

      <section className="card p-4 space-y-2">
        <Linea label="Ventas" value={`${p.cantidad_ventas} ventas`} />
        <Linea label="Total bruto" value={<MoneyDisplay value={p.total_ventas} />} />
        <Linea label="Efectivo" value={<MoneyDisplay value={p.total_efectivo} />} />
        {p.valor_final_transferencia > 0 && (
          <>
            <hr className="border-border" />
            <Linea
              label="A transferir"
              value={<MoneyDisplay value={p.valor_final_transferencia} className="text-brand font-bold" />}
            />
          </>
        )}
      </section>

      <div className="flex gap-2 flex-wrap">
        {isOperador && p.estado === "abierto" && (
          <button onClick={() => navigate(`/cuentas-cobro/${id}/cerrar`)} className="btn-primary">
            Cerrar corte
          </button>
        )}
        <Link to="/cuentas-cobro" className="btn-secondary">Volver</Link>
      </div>
    </div>
  );
}

function Linea({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-fg-secondary">{label}</span>
      <span>{value}</span>
    </div>
  );
}
